<template>
  <v-card
    tile
    outlined
    color="transparent"
    :loading="loading ? 'secondary' : false"
  >
    <v-card-title>Latest updates</v-card-title>

    <v-card-text v-if="updates.length">
      <div v-for="update in updates" :key="update.id">
        <!-- PROJECT CREATED -->
        <div v-if="update.event_name === 'projects.created'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            created

            <router-link
              v-if="update.subject"
              :to="{
                name: 'project',
                params: { project_id: update.subject.id }
              }"
              v-text="update.properties.attributes.name"
            />
            <span v-else
              >{{ update.properties.attributes.name }} (deleted)</span
            >

            project.
          </span>
        </div>

        <!-- PROJECT DELETED -->
        <div v-if="update.event_name === 'projects.deleted'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            deleted

            {{ update.properties.old.name }}

            project.
          </span>
        </div>

        <!-- PROJECT NAME UPDATED -->
        <div
          v-else-if="
            update.event_name === 'projects.updated' &&
              update.properties.attributes.hasOwnProperty('name')
          "
        >
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            changed project name from

            {{ update.properties.old.name }}

            to

            <router-link
              v-if="update.subject"
              :to="{
                name: 'project',
                params: { project_id: update.subject.id }
              }"
              v-text="update.properties.attributes.name"
            />
            <span v-else>{{ update.properties.attributes.name }} (deleted)</span
            >.
          </span>
        </div>

        <!-- TASK LIST CREATED -->
        <div v-if="update.event_name === 'task_lists.created'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            created

            <router-link
              v-if="update.subject"
              :to="{
                name: 'tasklist',
                params: { task_list_id: update.subject.id }
              }"
              v-text="update.properties.attributes.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task list.
          </span>
        </div>

        <!-- TASK LIST DELETED -->
        <div v-if="update.event_name === 'task_lists.deleted'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            deleted

            {{ update.properties.old.title }}

            task list.
          </span>
        </div>

        <!-- TASK LIST TITLE UPDATED -->
        <div
          v-if="
            update.event_name === 'task_lists.updated' &&
              update.properties.attributes.hasOwnProperty('title')
          "
        >
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            changed task list title from

            {{ update.properties.old.title }}

            to

            <router-link
              v-if="update.subject"
              :to="{
                name: 'tasklist',
                params: { task_list_id: update.subject.id }
              }"
              v-text="update.properties.attributes.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >
            .
          </span>
        </div>

        <!-- TASK LIST COMMENTED -->
        <div v-if="update.event_name === 'task_lists.discussed'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            commented on

            <router-link
              v-if="update.subject"
              :to="{
                name: 'tasklist',
                params: { task_list_id: update.subject.id }
              }"
              v-text="update.subject.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task list.
          </span>
        </div>

        <!-- TASK CREATED -->
        <div v-if="update.event_name === 'tasks.created'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            created

            <router-link
              v-if="update.subject"
              :to="{
                name: 'task',
                params: { task_id: update.subject.id }
              }"
              v-text="update.properties.attributes.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task.
          </span>
        </div>

        <!-- TASK DELETED -->
        <div v-if="update.event_name === 'tasks.deleted'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            deleted

            {{ update.properties.old.title }}

            task.
          </span>
        </div>

        <!-- TASK TITLE UPDATED -->
        <div
          v-if="
            update.event_name === 'tasks.updated' &&
              update.properties.attributes.hasOwnProperty('title')
          "
        >
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            changed task title from

            {{ update.properties.old.title }}

            to

            <router-link
              v-if="update.subject"
              :to="{
                name: 'tasklist',
                params: { task_list_id: update.subject.id }
              }"
              v-text="update.properties.attributes.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >.
          </span>
        </div>

        <!-- TASK COMPLETED UPDATED -->
        <div
          v-if="
            update.event_name === 'tasks.updated' &&
              update.properties.attributes.hasOwnProperty('completed')
          "
        >
          <!-- COMPLETED -->
          <span
            class="subtitle-1"
            v-if="update.properties.attributes.completed"
          >
            <latest-updates-causer :causer="update.causer" />

            completed

            <router-link
              v-if="update.subject"
              :to="{
                name: 'task',
                params: { task_id: update.subject.id }
              }"
              v-text="update.subject.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task.
          </span>

          <!-- INCOMPLETE -->
          <span class="subtitle-1" v-else>
            <latest-updates-causer :causer="update.causer" />

            set

            <router-link
              v-if="update.subject"
              :to="{
                name: 'task',
                params: { task_id: update.subject.id }
              }"
              v-text="update.subject.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task to incomplete.
          </span>
        </div>

        <!-- TASK COMMENTED -->
        <div v-if="update.event_name === 'tasks.discussed'">
          <span class="subtitle-1">
            <latest-updates-causer :causer="update.causer" />

            commented on

            <router-link
              v-if="update.subject"
              :to="{
                name: 'task',
                params: { task_id: update.subject.id }
              }"
              v-text="update.subject.title"
            />
            <span v-else
              >{{ update.properties.attributes.title }} (deleted)</span
            >

            task.
          </span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LatestUpdatesCauser from './LatestUpdatesCauser.vue'
export default {
  name: 'LatestUpdates',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    updates: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: { LatestUpdatesCauser }
}
</script>
